var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Entity } from '@decahedron/entity';
import { asset } from 'packages/media/util';
export var FileSourceType;
(function (FileSourceType) {
    FileSourceType["FORM"] = "form";
    FileSourceType["MANUAL"] = "manual";
})(FileSourceType || (FileSourceType = {}));
var thumbnailImageTypes = [
    'png',
    'jpg',
    'jpeg',
    'webp',
];
var thumbnailFileTypes = [
    'pdf',
];
var allowedFileTypes = __spreadArray(__spreadArray([], thumbnailImageTypes), thumbnailFileTypes);
var File = /** @class */ (function (_super) {
    __extends(File, _super);
    function File() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.id = null;
        _this.originName = null;
        _this.url = null;
        _this.label = null;
        _this.ownerId = null;
        _this.ownerType = null;
        _this.source = null;
        _this.uploaderId = null;
        _this.createdAt = null;
        _this.updatedAt = null;
        return _this;
    }
    Object.defineProperty(File.prototype, "extension", {
        get: function () {
            return this.originName.toUpperCase().split('.').pop();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(File.prototype, "thumbnail", {
        get: function () {
            return this.generateThumbnail(this.extension.toLowerCase(), this.url);
        },
        enumerable: false,
        configurable: true
    });
    File.prototype.generateThumbnail = function (extension, url) {
        if (allowedFileTypes.includes(extension)) {
            var options = this.getOperations(thumbnailFileTypes.includes(extension));
            return asset(url, options);
        }
    };
    File.prototype.getOperations = function (convert) {
        var options = {
            fit: 'clip',
            width: 160,
            height: Math.round(160 * 1.37),
        };
        if (convert) {
            options.fm = 'webp';
        }
        return options;
    };
    return File;
}(Entity));
export { File };
